import { getProfile } from "../redux/api/actions";
import { setCookie } from "../redux/features/actions";

const setCookieAndLoadProfile = async (context) => {
  const { store, req } = context;
  /*
   * If we are on the server, copy the cookie to the redux store so we can use it for server side data fetching
   */
  if (req?.headers?.cookie) {
    store?.dispatch(setCookie(req?.headers?.cookie));
  }

  let profile;

  try {
    profile = await store?.dispatch(getProfile());
  } catch (exception) {
    // User is not logged in
  }

  return profile;
};

export default setCookieAndLoadProfile;
